/**
 * Statut actif / inactif d’un profil de sync → tone BaseTag.
 */
export function getSyncProfileActiveTone(active) {
  return active ? 'success' : 'neutral';
}
